//#region src/constants/layout.ts
var RATIO_WIDTH = 16;
var RATIO_HEIGHT = 9;
var DEFAULT_WIDTH = 1200;
DEFAULT_WIDTH / RATIO_WIDTH * RATIO_HEIGHT;
var COLUMN_ALTERNATE_KEY_CHAR_WIDTH = 7.32;
var VIEW_TABLE_HEADER_FONT_SCALE = 14 / 12;
var VIEW_TABLE_HEADER_WEIGHT_SCALE = 1.04;
var MEMO_MIN_WIDTH = 116;
var MEMO_MIN_HEIGHT = 100;
var TABLE_GROUP_MIN_WIDTH = 160;
var TABLE_GROUP_MIN_HEIGHT = 100;
//#endregion
export { COLUMN_ALTERNATE_KEY_CHAR_WIDTH, DEFAULT_WIDTH, MEMO_MIN_HEIGHT, MEMO_MIN_WIDTH, TABLE_GROUP_MIN_HEIGHT, TABLE_GROUP_MIN_WIDTH, VIEW_TABLE_HEADER_FONT_SCALE, VIEW_TABLE_HEADER_WEIGHT_SCALE };
